export class CRMStats {
  MinInzuzoDate: Date;
  MaxInzuzoDate: Date;
  MinEnquiryDate: Date;
  MaxEnquiryDate: Date;
  InzuzoCount: number;
  EnquiryCount: number;
  LastInzuzoRun: Date;
  LastEnquiryRun: Date;
  FirstInzuzoAdword: Date;
  LastInzuzoAdword: Date;
  TotalInzuzoAdwords: number;
  FirstEnquiryAdword: Date;
  LastEnquiryAdword: Date;
  TotalEnquiryAdwords: number;
    

    constructor(data?: any) {
        if (data) {
          this.MinInzuzoDate = new Date(data.MinInzuzoDate);
          this.MaxInzuzoDate = new Date(data.MaxInzuzoDate);
          this.MinEnquiryDate = new Date(data.MinEnquiryDate);
          this.MaxEnquiryDate = new Date(data.MaxEnquiryDate);
          this.InzuzoCount = data.InzuzoCount;
          this.EnquiryCount = data.EnquiryCount;
          this.LastEnquiryRun = new Date(data.LastEnquiryRun);
          this.LastInzuzoRun = new Date(data.LastInzuzoRun);
          this.FirstInzuzoAdword = new Date(data.FirstInzuzoAdword);
          this.LastInzuzoAdword = new Date(data.LastInzuzoAdword);
          this.FirstEnquiryAdword = new Date(data.FirstEnquiryAdword);
          this.LastEnquiryAdword = new Date(data.LastEnquiryAdword);
          this.TotalInzuzoAdwords = data.TotalInzuzoAdwords;
          this.TotalEnquiryAdwords = data.TotalEnquiryAdwords;
        }
        else {
          this.MinInzuzoDate = new Date();
          this.MaxInzuzoDate = new Date();
          this.MinEnquiryDate = new Date();
          this.MaxEnquiryDate = new Date();
          this.InzuzoCount = 0;
          this.EnquiryCount = 0;
          this.LastInzuzoRun = new Date(2016, 3, 29);
          this.LastEnquiryRun = new Date(2017, 1, 19);
          this.FirstInzuzoAdword = new Date(2016, 3, 29);
          this.LastInzuzoAdword = new Date();
          this.FirstEnquiryAdword = new Date(2017, 1, 19);
          this.LastEnquiryAdword = new Date();
          this.TotalInzuzoAdwords = 0;
          this.TotalEnquiryAdwords = 0;
        }
    }
}
export class DownloadResult {
  CurrentDate: Date;
  DailyRecord: number;
  DailyUpdates: number;

}

export class Campaign {
  Id: number;
  CampaignCode: string;
  CampaignId: string;
  Metric: number;
  Provider: string;
  edit: boolean;
  tempCode: string;
  tempId: string;
}
export class CampaignFixer {
  ActiveMappings: Campaign[];
  CrmNotAdwords: Campaign[]; 
  AdwordsNotCrm: Campaign[];

  constructor() {
    this.ActiveMappings = [];
    this.CrmNotAdwords = [];
    this.AdwordsNotCrm = [];
  }
}

export class CustomerMap {
  Id: number;
  CRMName: string;
  XeroName: string;
  CRMLogin: string;
  AccountCode: string;
  edit: boolean;
  tempCRM: string;
  tempXero: string;
}
export class FourDates {
  StartI: Date;
  EndI: Date;
  StartE: Date;
  EndE: Date;
}
export class InvoiceLineError {
  Id: number;
  Uid: number;
  CRMLogin: string;
  Reference: string;
}

export class ItemCodeError {
  CRMLogin: string;
  LeadType: string;
}

export class InvoiceErrors {
  ICustomerMaps: CustomerMap[] = [];
  IInvoiceLineErrors: InvoiceLineError[] = [];
  ECustomerMaps: CustomerMap[] = [];
  EInvoiceLineErrors: InvoiceLineError[] = [];
  IItemCodeErrors: ItemCodeError[] = [];
  EItemCodeErrors: ItemCodeError[] = [];
}

export class ItemMap {
  Id: number;
  CRMLeadType: string;
  XeroItemCode: string;
  VATRate: string;
  edit: boolean;
  tempCRM: string;
  tempXero: string;
  tempVat: string;
}



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/_models/crmStats.ts